import { Component } from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Spinner.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cln = classnames.bind(styles);
const SPIN_DRAWING = 1;
const SPIN_ERASING = 2;
class Spinner extends Component {
  static propTypes = {
    /** Spinner animation type */
    animation: PropTypes.oneOf(['folding', 'spinning']),
    /** Your custom container class name to overwrite default styles */
    containerClassName: PropTypes.string,
    /** Your custom class name to overwrite default styles */
    className: PropTypes.string,
    /** Label which should be displayed on the right side of the spinner */
    label: PropTypes.string,
    /** Speed in milliseconds */
    speed: PropTypes.number,
    /** Size of triangle strokes. For smaller sizes e.g. with width lower than 30px stroke size around 0.5 improves sharpness */
    strokeSize: PropTypes.string,
    /** Set basic color version either dark or light. If you need custom colors overwrite them through your custom className */
    theme: PropTypes.oneOf(['dark', 'light']),
    /** Size of the spinner. If different size is needed then overwrite it by your custom class */
    size: PropTypes.oneOf(['large', 'big', 'small', 'compact'])
  };
  static defaultProps = {
    animation: 'folding',
    className: undefined,
    containerClassName: undefined,
    speed: 100,
    strokeSize: '1.15',
    theme: 'dark',
    label: '',
    size: 'large'
  };
  componentDidMount() {
    const {
      animation,
      speed
    } = this.props;
    if (animation === 'folding') {
      this.startSpinner();
    } else {
      this.spinner.style['animation-duration'] = `${speed * 6}ms`;
    }
  }
  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  startSpinner = () => {
    let prevPathKey = null;
    let currPathKey = 5;
    let spinState = SPIN_DRAWING;
    const paths = this.pathsCollection.children;
    const {
      speed
    } = this.props;
    this.timer = setInterval(() => {
      const currPath = paths[currPathKey];
      const prevPath = prevPathKey === null ? null : paths[prevPathKey];
      if (spinState === SPIN_DRAWING) {
        if (prevPathKey !== 0) {
          currPath.className.baseVal = styles['Spinner__item--dark'];
        }
        if (prevPath) {
          prevPath.className.baseVal = styles['Spinner__item--normal'];
        }
        if (prevPathKey === 0) {
          spinState = SPIN_ERASING;
        }
      }
      if (spinState === SPIN_ERASING) {
        currPath.className.baseVal = styles['Spinner__item--dimmed'];
        if (currPathKey === 0) {
          spinState = SPIN_DRAWING;
          prevPathKey = null;
          currPathKey = 5;
          return;
        }
      }
      prevPathKey = currPathKey;
      currPathKey = Math.abs((currPathKey - 1 + 6) % 6);
    }, speed);
  };
  render() {
    const {
      className,
      containerClassName,
      animation,
      theme,
      size,
      strokeSize,
      label
    } = this.props;
    const containerClasses = cln(containerClassName, 'SpinnerContainer');
    const spinnerClasses = cln(className, 'Spinner', {
      [`Spinner--${animation}`]: true,
      [`Spinner--${theme}`]: true,
      [`Spinner--${size}`]: true
    });
    return /*#__PURE__*/_jsxs("span", {
      className: containerClasses,
      children: [/*#__PURE__*/_jsx("svg", {
        width: "0",
        ref: spinner => {
          this.spinner = spinner;
        },
        "data-testid": "rc-spinner",
        className: spinnerClasses,
        version: "1.1",
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsxs("g", {
          ref: pathsCollection => {
            this.pathsCollection = pathsCollection;
          },
          strokeLinejoin: "round",
          strokeWidth: strokeSize,
          children: [/*#__PURE__*/_jsx("path", {
            className: cln(`Spinner__item--${animation === 'folding' ? 'dimmed' : 'dimmed'}`),
            d: "m12.371 11.91v-9.8582l-8.5374 4.9291z"
          }), /*#__PURE__*/_jsx("path", {
            className: cln(`Spinner__item--${animation === 'folding' ? 'dimmed' : 'dimmed'}`),
            d: "m3.1788 8.0674v9.8582l8.5374-4.9291z"
          }), /*#__PURE__*/_jsx("path", {
            className: cln(`Spinner__item--${animation === 'folding' ? 'dimmed' : 'dark'}`),
            d: "m12.361 23.949v-9.8582l-8.5374 4.9291z"
          }), /*#__PURE__*/_jsx("path", {
            className: cln(`Spinner__item--${animation === 'folding' ? 'dimmed' : 'normal'}`),
            d: "m13.647 14.09v9.8582l8.5374-4.9291z"
          }), /*#__PURE__*/_jsx("path", {
            className: cln(`Spinner__item--${animation === 'folding' ? 'dimmed' : 'normal'}`),
            d: "m22.821 17.926v-9.8582l-8.5374 4.9291z"
          }), /*#__PURE__*/_jsx("path", {
            className: cln(`Spinner__item--${animation === 'folding' ? 'dimmed' : 'normal'}`),
            d: "m13.647 2.0517v9.8582l8.5374-4.9291z"
          })]
        })
      }), label && /*#__PURE__*/_jsx("span", {
        className: cln('Spinner-label'),
        children: label
      })]
    });
  }
}
export default Spinner;